import { Component, Directive, forwardRef, Attribute, OnChanges, SimpleChanges, Input, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';


import { EqualValidatorDirective } from '../../../_directives/equal-validator.directive';
import { UserService } from '../../../_services/user.service';

export interface UserModel {
    userId: number,
    userName: string
}

@Component({
    selector: 'app-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['./resetpassword.component.css']
})

export class ResetpasswordComponent extends DialogComponent<UserModel, boolean> implements OnInit {
    model: any = {};
    loading: boolean;
    userId: string;
    userName: string;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();
    
    constructor(dialogService: DialogService, private userService: UserService) {
        super(dialogService);
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }
    
    reset() {
        this.loading = true;
        this.model.id = this.userId;
        this.message = '';
        this.userService.resetPassword(this.model).subscribe(data => {
            this.close();
            this.result = true;
        }, error => {
            this.message = error.json().message;
        }, () => {
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/resetpassword/resetpassword.component.ts